import React from 'react'
import parentsteponeStyle from './ParentRegisterMobilStepOne.module.css'

export default function ParentRegisterMobilStepOne() {
  return (
    <>
      <div className={parentsteponeStyle.parentmobilsteponepage}>
        <div className='row'>
          <div className='col-7'>
            <h3> Welcome </h3>
          </div>
          <div className='col-5'>
            <div className={parentsteponeStyle.parentprofileBox}>
              <div className={parentsteponeStyle.parentprofileImg}>
                <div className={parentsteponeStyle.parentprofileImginner}>
                  <img src="/static/media/lady-img.965cec88308ed5853d74.png" className="img-fluid w-100 h-100 rounded-circle" />
                </div>
              </div>
              <div className={parentsteponeStyle.parentprofileeditBox}>
                <input type="file" className={parentsteponeStyle.parentprofilechooseInput} accept=".png, .jpg, .jpeg" />
                <label className={parentsteponeStyle.parentprofileLabel} for="imageUpload" />
              </div>
            </div>
          </div>
        </div>
        <h6> Sign up to join </h6>
        <h5> Parent Information </h5>
        <div className='row'>
          <div className='col-12'>
            <div className="mb-3">
              <input type="text" className={`${parentsteponeStyle.parentoneInput} form-control`} placeholder='First Name' />
            </div>
          </div>
          <div className='col-12'>
            <div className="mb-3">
              <input type="text" className={`${parentsteponeStyle.parentoneInput} form-control`} placeholder='Last Name' />
            </div>
          </div>
          <div className='col-12'>
            <div className="mb-3">
              <input type="text" className={`${parentsteponeStyle.parentoneInput} form-control`} placeholder='Name of Publisher' />
            </div>
          </div>
          <div className='col-12'>
            <div className="mb-3">
              <input type="email" className={`${parentsteponeStyle.parentoneInput} form-control`} placeholder='Email Address' />
            </div>
          </div>
          <div className='col-12'>
            <div className="mb-3">
              <input type="number" className={`${parentsteponeStyle.parentoneInput} form-control`} placeholder='Phone Number' />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
